<div class="container single-view" id="view-retailer">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/retailers" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'RETAILERS.BTN_BACK_TO_RETAILERS' | translate }}</a>
      </div>
      <div class="switch-wr">
        @if (allowUpdateRetailer) {
          <p-selectButton
            class="status-switch"
            [class.status-active]="stateInitialValue === true"
            [options]="stateOptions"
            optionLabel="displayLabel"
            optionValue="value"
            [allowEmpty]="false"
            [(ngModel)]="stateInitialValue"
            (onChange)="onStateChange($event)">
            <ng-template #item let-option>
              <span
                class="status-option"
                [attr.data-testid]="'btn-' + option.label">
                <i class="pi pi-check status-check" aria-hidden="true"></i>
                <span>{{ option.displayLabel }}</span>
              </span>
            </ng-template>
          </p-selectButton>
        }
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="retailer-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'RETAILERS.VIEW_RETAILER_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (retailer.name) {
                  <span data-testid='retailer-name'>{{ retailer.name | defaultValue }}</span>
                }
                @if (retailer.isActive) {
                  <span class="tag tag-green" data-testid="retailer-status">{{ 'ENUMS.ACTIVE' | translate }}</span>
                }
                @if (!retailer.isActive) {
                  <span class="tag tag-red" data-testid="retailer-status">{{ 'ENUMS.INACTIVE' | translate }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 basis-full mt-2">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='retailer-address-name' class="flex items-center mr-2" pTooltip="{{ 'RETAILER_SINGLE_VIEW.TOOLTIP_ADDRESS' | translate }}" tooltipPosition="top"><i class="icon icon-marker mr-1"></i>{{ retailer.street | formatAddress: retailer.zip: retailer.city }}</span>
            <span data-testid='retailer-country-name' class="flex items-center mr-2" pTooltip="{{ 'RETAILER_SINGLE_VIEW.TOOLTIP_COUNTRY' | translate }}" tooltipPosition="top"><i class="icon icon-country mr-1"></i>{{ retailer.isoCountry | CountryTransformPipe | async | defaultValue }} </span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowManageUsers) {
              <button data-testid='retailer-manageusers-btn' class="btn outline-btn" (click)="manageRetailerUsers()">{{ 'RETAILER_SINGLE_VIEW.BTN_ADD_USERS' | translate }}</button>
            }
            @if (allowUpdateRetailer) {
              <button data-testid='retailer-edit-btn' class="btn primary-btn" (click)="goToEditRetailer()">{{ 'RETAILER_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='retailer-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'RETAILERS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mt-6 mb-4 text-wr">
            <!-- main content -->
            <section class="row">
              <div data-testid='retailer-location' class="col-12 col-md-6">
                @if (isValidLocation) {
                  <div>
                    <div #mapContainer id="map" class="w-full tall"></div>
                  </div>
                } @else {
                  <div class="no-geolocation">
                    {{ 'RETAILER_SINGLE_VIEW.NO_VALID_GEOLOCATION' | translate }}
                  </div>
                }
              </div>
              <div class="col-12 col-md-6">
                <h4 data-testid='retailer-details'>{{ 'RETAILER_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid='retailer-country-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.COUNTRY' | translate }}</dt>
                  <dd data-testid='retailer-country' class="value pt-3 pb-3">{{ retailer.isoCountry |
                  CountryTransformPipe | async | defaultValue }}</dd>

                  <dt data-testid='retailer-stateprovince-label' class="label grid-cols-1 pt-3">{{ 'RETAILER_SINGLE_VIEW.STATE_PROVINCE' |
                  translate }}</dt>
                  <dd data-testid='retailer-stateprovince' class="value pt-3 pb-3">{{ retailer.stateProvince | defaultValue }}</dd>

                  <dt data-testid='retailer-stateprovinceromanised-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.STATE_PROVINCE_ROMANIZED' | translate }}</dt>
                  <dd data-testid='retailer-stateprovinceromanised' class="value pt-3 pb-3">{{ retailer.stateProvinceRomanised |
                  defaultValue }}</dd>

                  <dt data-testid='retailer-city-label' class="label grid-cols-1 pt-3">{{ 'RETAILER_SINGLE_VIEW.CITY' |
                  translate }}</dt>
                  <dd data-testid='retailer-city' class="value pt-3 pb-3">{{ retailer.city | defaultValue }}</dd>

                  <dt data-testid='retailer-cityromanised-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.CITY_ROMANIZED' | translate }}</dt>
                  <dd data-testid='retailer-cityromanised' class="value pt-3 pb-3">{{ retailer.cityRomanised |
                  defaultValue }}</dd>

                  <dt data-testid='retailer-street-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.ADDRESS' | translate }}</dt>
                  <dd data-testid='retailer-street' class="value pt-3 pb-3">{{ retailer.street | defaultValue}}</dd>

                  <dt data-testid='retailer-zip-label' class="label grid-cols-1 pt-3">{{ 'RETAILER_SINGLE_VIEW.ZIP_CODE'
                  | translate }}</dt>
                  <dd data-testid='retailer-zip' class="value pt-3 pb-3">{{ retailer.zip | defaultValue }}</dd>
                </dl>
              </div>
            </section>
            <section class="row">
              <div class="col-12">
                <h4>{{ 'RETAILER_SINGLE_VIEW.BUSINESS_DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid='retailer-code-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.RETAILER_CODE' | translate }}</dt>
                  <dd data-testid='retailer-code' class="value pt-3 pb-3">{{ retailer.code | defaultValue }}</dd>

                  <dt data-testid='retailer-retailertype-label' class="label grid-cols-1 pt-3">{{
                  'RETAILER_SINGLE_VIEW.RETAILER_TYPE' | translate }}</dt>
                  <dd data-testid='retailer-retailertype' class="value pt-3 pb-3">
                    @if (retailer.type?.id) {
                      <a [routerLink]="['/retailer-types/', retailer.type?.id]" class="inline-flex items-center link">{{ retailer.type?.name }}</a>
                    } @else {
                      {{ retailer.type?.name | defaultValue }}
                    }
                  </dd>

                  <dt data-testid="retailer-brands-label" class="label grid-cols-1 pt-3">
                    {{ 'RETAILER_SINGLE_VIEW.BRANDS' | translate }}
                  </dt>
                  <dd data-testid="retailer-brands" class="value pt-3 pb-3">
                    @if (retailer.brands?.length) {
                      @for (brand of retailer.brands; track brand; let isLast = $last) {
                        <span [class.inactive-label]="brand.isActive === false">{{ brand.name }}</span>@if (!isLast) {
                        <span>, </span>
                      }
                    }
                  } @else {
                    <span>{{ 'RETAILER_SINGLE_VIEW.NO_BRANDS_AVAILABLE' | translate }}</span>
                  }
                </dd>

                <dt data-testid='retailer-market-label' class="label grid-cols-1 pt-3">{{
                'RETAILER_SINGLE_VIEW.MARKET' | translate }}</dt>
                <dd data-testid='retailer-market' class="value pt-3 pb-3">
                  @if (retailer.market.id) {
                    <a [routerLink]="['/markets/', retailer.market.id]" class="inline-flex items-center link">{{ retailer.market.name }}</a>
                  } @else {
                    {{ retailer.market.name | defaultValue }}
                  }
                </dd>

                <dt data-testid='retailer-marketcode-label' class="label grid-cols-1 pt-3">{{
                'RETAILER_SINGLE_VIEW.MARKET_CODE' | translate }}</dt>
                <dd data-testid='retailer-marketcode' class="value pt-3 pb-3">{{ retailer.market.code | defaultValue }}</dd>
                @if (showDistributionChannel) {
                <dt data-testid='retailer-distributionchannels-label' class="label grid-cols-1 pt-3">{{
                'RETAILER_SINGLE_VIEW.DISTRIBUTION_CHANNELS' | translate }}</dt>
                <dd data-testid='retailer-distributionchannels' class="value pt-3 pb-3">
                  @if (retailer.distributionChannels && retailer.distributionChannels.length > 0) {
                    @for (channel of retailer.distributionChannels; track channel; let i = $index) {
                      <a [routerLink]="['/distribution-channels', channel.id]" class="inline-flex items-center link">
                        {{ channel.name }}
                      </a>@if (retailer.distributionChannels && i < retailer.distributionChannels.length - 1) {
                      <span>, </span>
                    }
                  }
                } @else {
                  <span>{{ 'RETAILER_SINGLE_VIEW.NO_CHANNELS_AVAILABLE' | translate }}</span>
                }
              </dd>
              }

              @if (company?.hasRetailerBusinessGroup) {
                <dt data-testid='retailer-businessgroup-label' class="label grid-cols-1 pt-3">
                {{ 'RETAILER_SINGLE_VIEW.BUSINESS_GROUP' | translate }}</dt>
              }
              @if (company?.hasRetailerBusinessGroup) {
                <dd data-testid='retailer-businessgroup' class="value pt-3 pb-3">
                  @if (retailer.businessGroup?.id) {
                    <a [routerLink]="['/business-groups/', retailer.businessGroup?.id]" class="inline-flex items-center link">
                      {{ retailer.businessGroup?.name }}
                    </a>
                  } @else {
                    {{ retailer.businessGroup?.name | defaultValue }}
                  }
                </dd>
              }

              <dt data-testid='retailer-externalid-label' class="label grid-cols-1 pt-3">{{
              'RETAILER_SINGLE_VIEW.EXTERNAL_RETAILER_ID' | translate }}</dt>
              <dd data-testid='retailer-externalid' class="value pt-3 pb-3">{{ retailer.externalPosId | defaultValue
              }}</dd>

            </dl>
          </div>
        </section>

        @if ( retailerAttributesFeatureEnabled && showRetailerAttributeDetails && retailerAttributeDisplayItems.length) {
          <section class="row">
            <div class="col-12">
              <h4 data-testid="retailer-attribute-details">
                {{ 'RETAILER_SINGLE_VIEW.RETAILER_ATTRIBUTES' | translate }}
              </h4>
              <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              <dl class="details-grid">
                @for (attribute of retailerAttributeDisplayItems; track attribute.code) {
                <dt class="label grid-cols-1 pt-3">
                  {{ attribute.name | defaultValue }}
                  @if (attribute.changesOverTime) {
                    <i class="icon icon-clock ml-1" aria-hidden="true"></i>
                  }
                </dt>
                <dd [attr.data-testid]="'retailer-attribute-' + attribute.code" class="value pt-3 pb-3">
                  {{ attribute.value | defaultValue }}
                </dd>
                }
              </dl>
            </div>
          </section>
        }

        <section class="row">
          <div class="col-12">
            <h4 data-testid="retailer-operation-details">{{ 'RETAILER_SINGLE_VIEW.OPERATIONAL_INFO' | translate }}
            </h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
            <dl class="details-grid">
              <dt data-testid="retailer-openingdate-label" class="label grid-cols-1 pt-3">{{
              'RETAILER_SINGLE_VIEW.OPENING_DATE' | translate }}</dt>
              <dd data-testid="retailer-openingdate" class="value pt-3 pb-3">{{ retailer.openingDate ?
              (retailer.openingDate | date: 'dd-MM-yyyy') : (retailer.openingDate | defaultValue) }}</dd>

              <dt data-testid="retailer-closingdate-label" class="label grid-cols-1 pt-3">{{
              'RETAILER_SINGLE_VIEW.CLOSING_DATE' | translate }}</dt>
              <dd data-testid="retailer-closingdate" class="value pt-3 pb-3">{{ retailer.closingDate ?
              (retailer.closingDate | date: 'dd-MM-yyyy') : (retailer.closingDate | defaultValue) }}</dd>

              @if (companyHasCpo) {
                <dt data-testid="retailer-hascpo-label" class="label grid-cols-1 pt-3">{{
                'RETAILER_SINGLE_VIEW.CPO' | translate }}</dt>
              }
              @if (companyHasCpo) {
                <dd data-testid="retailer-hascpo" class="value pt-3 pb-3">{{ (retailer.hasCpo ?
                'BOOLEANS.YES' : 'BOOLEANS.NO') | translate }}</dd>
              }
            </dl>
          </div>
        </section>
        <section class="row">
          <div class="col-12">
            <h4 data-testid="retailer-contact-details">{{ 'RETAILER_SINGLE_VIEW.CONTACT_INFORMATION' | translate }}
            </h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
            <dl class="details-grid">
              <dt data-testid="retailer-email-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_SINGLE_VIEW.EMAIL'
              | translate }}</dt>
              <dd data-testid="retailer-email" class="value pt-3 pb-3">{{ retailer.email | defaultValue }}</dd>

              <dt data-testid="retailer-comments-label" class="label grid-cols-1 pt-3">{{
              'RETAILER_SINGLE_VIEW.COMMENTS' | translate }}</dt>
              <dd data-testid="retailer-comments" class="value pt-3 pb-3">{{ retailer.comment | defaultValue }}</dd>
            </dl>
          </div>
        </section>
        <section class="row">
          <div class="col-12 mb-3">
            <h4 data-testid="retailer-users-details">{{ 'RETAILER_SINGLE_VIEW.RETAILER_USERS' | translate }}</h4>
            <hr role="presentation" class="w-full mb-2 mt-3 border-t">
          </div>
          <div class="col-12">
            <p-table data-testid="retailer-users" [value]="retailerUsersData" #dtRetailerUsersTable>
              <ng-template #header>
                <tr>
                  <th>
                    <div class="header-wr">
                      {{ 'RETAILER_SINGLE_VIEW.FIRST_NAME' | translate }}
                    </div>
                  </th>
                  <th>
                    <div class="header-wr">
                      <span class="col-name">{{ 'RETAILER_SINGLE_VIEW.LAST_NAME' | translate }}</span>
                    </div>
                  </th>
                  <th>
                    <div class="header-wr">
                      <span class="col-name">{{ 'RETAILER_SINGLE_VIEW.USERNAME' | translate }}</span>
                    </div>
                  </th>
                  <th>
                    <div class="header-wr">
                      <span class="col-name">{{ 'RETAILER_SINGLE_VIEW.EMAIL' | translate }}</span>
                    </div>
                  </th>
                  <th>
                    <div class="header-wr">
                      <span class="col-name">{{ 'RETAILER_SINGLE_VIEW.ROLE' | translate }}</span>
                    </div>
                  </th>
                  <th>
                    <div class="header-wr">
                      <span class="col-name">{{ 'RETAILER_SINGLE_VIEW.STATUS' | translate }}</span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template #body let-retailerUser>
                <tr>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.FIRST_NAME' | translate }}:</span>
                    {{ retailerUser.firstName | defaultValue }}
                  </td>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.LAST_NAME' | translate }}:</span>
                    {{ retailerUser.lastName | defaultValue }}
                  </td>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.USERNAME' | translate }}:</span>
                    @if (retailerUser?.id) {
                      <a [routerLink]="['/users/', retailerUser?.id]" class="inline-flex items-center link">{{ retailerUser?.username }}</a>
                    } @else {
                      {{ retailerUser.username | defaultValue }}
                    }
                  </td>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.EMAIL' | translate }}:</span>
                    {{ retailerUser.email | defaultValue }}
                  </td>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.ROLE' | translate }}:</span>
                    {{ retailerUser.roleName }}
                  </td>
                  <td>
                    <span class="p-column-title">{{ 'RETAILER_SINGLE_VIEW.STATUS' | translate }}:</span>
                    @if (retailerUser.isActive) {
                      <span class="tag tag-green">{{ retailerUser.status
                      ?? ('BOOLEANS.ACTIVE' | translate) }}</span>
                    } @else {
                      <span class="tag tag-red">{{ retailerUser.status ?? ('BOOLEANS.INACTIVE' | translate)
                      }}</span>
                    }
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td [attr.colspan]="7">{{ 'RETAILER_SINGLE_VIEW.NO_DATA' | translate }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </section>
        <!-- /main content -->
      </div>
    </div>
  </div>
</div>
</div>
</div>


<!-- Modalbox: retailer user removal -->
<p-dialog [header]="'MODALBOXES.TITLE_REMOVE_USER_FROM_STORE' | translate" [(visible)]="displayUserFromRetailerModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form [formGroup]="userRemovalForm">
    <p class="text-base" [innerHTML]="'MODALBOXES.DESCRIPTION_REMOVE_USER_FROM_STORE' | translate"></p>
    <div class="field-wr">
      <p class="text-base mt-1">{{ 'MODALBOXES.LABEL_REMOVE_USER_FROM_STORE' | translate }}</p>
      <textarea class="mt-6 text-sm" formControlName="removalReason" rows="3"
      placeholder="{{ 'MODALBOXES.REMOVAL_REASON_PLACEHOLDER' | translate }}"></textarea>
      @if (userRemovalForm.get('removalReason')?.invalid && userRemovalForm.get('removalReason')?.touched) {
        <ng-container
          class="error">
          <small class="error">{{ 'MODALBOXES.HINT_REMOVAL_REASON_REQUIRED' | translate }}</small>
        </ng-container>
      }
    </div>
  </form>
  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="onCancelRemoval()">{{ 'MODALBOXES.BTN_CANCEL_REMOVE_USER' |
    translate }}</button>
    <button type="button" class="btn primary-btn" (click)="onRemoveUser()" [disabled]="userRemovalForm.invalid">{{
    'MODALBOXES.BTN_REMOVE_USER' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Confirmation: state change -->
<p-confirmDialog key="confirm-state-change-dialog" (onHide)="stateInitialValue = retailer.isActive">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_CONFIRM_STATE_CHANGE' | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button id="btn-cancel-change" type="button" class="btn outline-btn" (click)="onCancelStateChange()">{{
    'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}</button>
    <button id="btn-confirm-update" type="button" class="btn primary-btn" (click)="onConfirmStateChange()">{{
    'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}</button>
  </ng-template>
</p-confirmDialog>

<!-- Delete retailer -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_RETAILER'"
(onClose)="deleteRetailer($event)"></dialog-reason>
